import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { messageApprovalSubjects } from '@/@vxapp/Messages/Approvals/messageApprovalTypes'

export default [
  { heading: 'CRM' },
  {
    page: PageMeta.Calendar.Full,
    title: 'Calendar',
    icon: { icon: PageMeta.Calendar.Full.Icon },
    to: PageMeta.Calendar.Full.Name,
  },
  {
    page: PageMeta.Customers.List,
    title: 'Customers',
    icon: { icon: PageMeta.Customers.List.Icon },
    to: PageMeta.Customers.List.Name,
  },
  {
    page: PageMeta.Messages.list,
    title: 'Messages',
    icon: { icon: PageMeta.Messages.list.icon },
    to: PageMeta.Messages.list.name,
  },
  {
    page: { Meta: { subject: messageApprovalSubjects.list, layout: null } },
    title: 'Email approvals',
    icon: { icon: 'tabler-mail-check' },
    to: 'apps-messages-approvals',
  },
]
